"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDocumentActionTranslation = void 0;
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const documentActionTranslationMap = {
    created: 'activity-feed_document_uploaded',
    updated: 'activity-feed_document_updated',
    deleted: 'activity-feed_document_deleted',
};
const useDocumentActionTranslation = () => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const getDocumentActionTranslation = (action) => {
        if (action) {
            return translate(documentActionTranslationMap[action]);
        }
        return '';
    };
    return { getDocumentActionTranslation };
};
exports.useDocumentActionTranslation = useDocumentActionTranslation;
//# sourceMappingURL=useDocumentActionTranslation.js.map